import { ChangeDetectionStrategy, Component, signal, ViewEncapsulation, computed, inject } from '@angular/core';
import {
    IOnboardingReportData,
    IOnboardingReportLocation,
    IOnboardingReportParameter,
    IOnboardingReportSummary,
} from '@fi-app/fi-onboarding/fi-onboarding-report/fi-onboarding-report';
import { FiOnboardingReportDetailsBase } from '../fi-onboarding-report-details-base';
import { FiOnboardingReportTableFilterHelperService } from '@fi-app/fi-onboarding/fi-onboarding-report/shared/fi-onboarding-report-table-filter-helper.service';

@Component({
    selector: 'fi-onboarding-report-locations-widget',
    templateUrl: './fi-onboarding-report-locations-widget.component.html',
    styleUrl: './fi-onboarding-report-locations-widget.component.scss',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-onboarding-report-locations-widget' },
    standalone: false,
})
export class FiOnboardingReportLocationsWidgetComponent extends FiOnboardingReportDetailsBase {
    private _reportData = signal<IOnboardingReportData>(undefined);

    protected onboardingLocations = computed<IOnboardingReportLocation[]>(
        () => this._reportData()?.OnboardingLocations ?? [],
    );
    protected participantsSummary = computed<IOnboardingReportSummary>(
        () => this._reportData()?.ParticipantsSummary ?? undefined,
    );

    protected loadReportData() {
        const parameter = this.getReportParameter();
        this.fiOnboardingReportService.getReportData(parameter).then((result) => {
            this._reportData.set(result);
            this.checkAvailableBusinessUnits();
        });
    }
    private getReportParameter(): IOnboardingReportParameter {
        const parameter = this.fiOnboardingReportHelperService.getReportParameter({
            widget: this.widget,
            filter: this.currentFilter,
            loadOnboardingLocations: true,
            loadParticipantsSummary: true,
        });
        parameter.SearchText = this.searchText;
        return parameter;
    }

    private checkAvailableBusinessUnits() {
        const availableItemsByData =
            this.fiOnboardingReportTableFilterHelperService.getAvailableUnitsAreasBusinessAreas(
                this.availableItems.Onboardings,
                this.currentFilter.OnboardingIds,
                this.currentFilter,
                this.availableItems,
                { hideDeactivatedUnits: true },
            );
        this.availableItemsByDataChange.emit(availableItemsByData);
    }
}
